import config from "../../config";

var testing = false;
if (testing) {

  const options = {
    body: {
      bgColor: 'yellow'
    },
    menu: {
      border: 'solid 2px red',
      bgColor: '#111',
      fontColor: '#fff',
      hidden: false,
      items: [{
        itemKey: 'PROFILE',
        name: 'Custom Profile Link',
        sortOrder: 999,
        hidden: false
      },
        {
          itemKey: 'EVENTS',
          name: 'Calendar',
          sortOrder: 1,
          hidden: false
        },
        {
          itemKey: 'LOGOUT',
          sortOrder: -1,
          hidden: false
        },
        {
          itemKey: 'STORE',
          name: 'Shop',
          sortOrder: 2,
          hidden: false
        },
        {
          itemKey: 'MEMBERSHIPS',
          name: '',
          sortOrder: 999,
          hidden: true
        },
        {
          itemKey: 'VISITS',
          name: 'We miss you',
        },
      ]
    }
  }

  const newDiv = document.createElement('div');
  newDiv.id = 'PSB_OPTIONS';
  newDiv.textContent = `${JSON.stringify(options)}`;
  document.body.appendChild(newDiv);
}

const displayEnvironment = () => {
  return config.ENVIRONMENT === 'Production' ? '' : config.ENVIRONMENT + ' ';
}

const _opts = () => {
  const PSB_OPTIONS = document.getElementById('PSB_OPTIONS')?.innerHTML;
  if (PSB_OPTIONS) {
    let _options = JSON.parse(PSB_OPTIONS);
    if (_options) {
      return _options;
    }
  }
  return null;
}

export const CONSTANTS = {
  HOST: '',
  UTYPE_CLIENT: 1,
  UTYPE_CUSTOMER: 2,
  UTYPE_ADMIN: 4,
  SESSION_USER: 'SESSION_USER',
  MENU: 'MENU',
  PANES: 'PANES',
  X_APP_HEADER: 'x-app-header',
  PSB_UID: 'PSB_UID',
  PSB_SID: 'PSB_SID',
  PSB_CID: 'PSB_CID',
  VISITOR_ID: 'visitor-id',
  TOAST_TIMEOUT: 2500,
  SITE_OPTIONS: _opts(),
  ENVIRONMENT: config.ENVIRONMENT,
  DISPLAY_ENVIRONMENT: displayEnvironment(),
  ENTITY_TYPE: {
    CUSTOMER: 1,
    INVENTORY: 2
  },
  EXT_APPLICATION: {
    SQUARE: 1,
    STRIPE: 2
  },
  USER_STATUS: {
    NONE: -1,
    ACTIVE: 1,
    INACTIVE: 2,
    PENDING: 3,
    DELETED: 4
  },
  TIME_UNIT: {
    MINUTE: 1,
    HOUR: 2,
    DAY: 3
  },
  CHARGE_TYPE: {
    CARD: 1,
    CASH: 2,
    GIFT_CARD: 3,
    UNSPECIFIED: 4
  },
  STATUS: {
    NONE: -1,
    ACTIVE: 1,
    INACTIVE: 2,
  },
  FAMILY_MEMBER_TYPE: {
    NONE: -1,
    CHILD: 1,
    PARENT: 2,
    CAREGIVER: 3,
    OTHER: 4
  },
  RESERVATION_STATUS: {
    NONE: -1,
    RESERVED: 1,
    CONFIRMED: 2,
    WAIT_LIST: 3,
    CHECKED_IN: 4,
    ARCHIVED: 5,
    CANCELLED: 6,
    EVENT_CANCELLED: 7
  },
  WAITLIST_STATUS: {
    NONE: -1,
    PENDING: 1,
    ACTIVE: 2,
    INACTIVE: 3
  },
  PERK_TYPE: {
    NONE: -1,
    PRODUCT: 1,
    DISCOUNT: 2,
    CREDIT: 3
  },
  PERK_RECURRENCE_TYPE: {
    NONE: -1,
    INITIAL: 1,
    RECURRING: 2
  },
};